<template>
  <section
    v-if="hasData"
    class="local-lm-orders-title-mtop"
  >
    <div class="lm-header">
      <h3
        v-if="available && available.length === 0 && hasSummited"
        class="subtitle is-5"
        v-t="$t('Orders.noResults')"
      />
      <h3
        v-if="available && available.length > 0"
        class="subtitle is-5"
        v-t="$t('Orders.results')"
      />
    </div>
    <div
      v-if="available && available.length"
    >
      <div
       class="container local-lm-order-btns"
      >
        <partner-table-filter
          v-bind="{ type }"
        />
        <b-button
          :icon-right="iconOrd"
          class="lm-default-btn--no-outline local-lm-xs-marginTop"
          @click.prevent="ord"
        />
      </div>
      <b-table
        ref="table"
        :data="available"
        :paginated="isPaginated"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :checkbox-position="checkboxPosition"
        :checked-rows.sync="checkedRows"
        :total="totalCount"
        :current-page.sync="currentPage"
        backend-pagination
        per-page="13"
        detail-key="id"
        checkable
        detailed
        hoverable
        narrowed
        class="local-lm-orders-table"
      >
        <b-table-column
          field="id"
          v-slot="props"
          :label="$t('Orders.labelOrder')"
          width="160"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.orderId'"
              />
              {{ props.row.supplierOrderCode }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.store'"
              >
              </span>
              {{ props.row.store.name }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          v-slot="props"
          width="200"
        >
          <div>
            <p
              v-if="type === 'available'"
            >
              <span
                class="local-lm-orders-label"
                v-t="'Orders.collectionRequest'"
              />
              {{ props.row.supplierCollectionRequestDate | stripHour }}
            </p>
            <p
              v-if="type === 'dispatch'"
            >
              <span
                class="local-lm-orders-label"
                v-t="'Orders.partnerCollect'"
              />
              {{ props.row.collectedByPartnerDate | stripHour }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.supplierID'"
              />
              {{ props.row.supplierID }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          v-if="type === 'available'"
          field="id"
          v-slot="props"
          width="200"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.expectedCollection'"
              />
              {{ props.row.supplierExpectedCollectionDate | stripHour }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          v-if="type === 'available'"
          field="id"
          v-slot="props"
          width="200"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.confirmedCollection'"
              />
              {{ props.row.partnerExpectedCollectionDate | stripHour }} » {{ _applySomeExceptions(props.row) }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          v-slot="props"
          width="200"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.partner'"
              />
              {{ props.row.partner }}
              <transport-communications
                v-if="canSeeTransportComunications(props.row)"
                class="local-lm__partner-status"
                :state="props.row.communicationStatus"
              />
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="id"
          v-slot="props"
          width="200"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.plate'"
              />
              {{ props.row.vehicleRegistration }}
            </p>
          </div>
        </b-table-column>
        <b-table-column v-slot="props">
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.labelState'"
              />
              {{
                props.row.supplyOrderState
                  ? $t(`Orders.${props.row.supplyOrderState}`)
                  : $t('Errors.warningNone')
              }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          v-if="$route.name !== 'Dispatch'"
          width="20"
          field="id"
        >
          <template v-slot:header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp3')"
              type="is-dark"
            >
              <b-button
                v-show="generalBtnRestoreVisible"
                icon-right="history"
                class="local-lm-btn-header"
                @click.prevent="callActions(checkedRows, allActions)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <btn-restore-order
                v-if="canRestore(props.row)"
                v-bind="props.row"
                :actions="allActions"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          width="20"
          field="id"
        >
          <template v-slot:header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp1')"
              position="is-left"
              type="is-dark"
            >
              <b-button
                icon-right="printer"
                class="local-lm-btn-header"
                @click.prevent="downloadLabel(checkedRows)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-tooltip
                :label="$t('Orders.tooltipOp1')"
                position="is-left"
                type="is-dark"
              >
                <b-button
                  icon-right="printer"
                  class="local-lm-btn-row"
                  @click.prevent="downloadLabel([ ...props.row ])"
                />
              </b-tooltip>
            </span>
          </template>
        </b-table-column>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin } from '@/mixins'
import PartnerTableFilter from '@/components/filters/PartnerTableFilter'
import BtnRestoreOrder from '@/components/miscellaneous/BtnRestoreOrder'
import TransportCommunications from '@/components/miscellaneous/TransportCommunications'
import { services } from '@/services'

export default {
  name: 'PartnerOrders',
  beforeCreate () {
    this.$store.dispatch('orders/flushAvailableOrders')
  },
  mixins: [
    mixin.dates,
    mixin.notifications,
    mixin.transports
  ],
  computed: {
    ...mapGetters('orders', [
      'available',
      'actions'
    ]),
    allActions () {
      return this.actions.revertSupplier
    },
    totalCount () {
      return this.$store.getters['orders/totalCount']
    },
    currentPage: {
      get () {
        return this.$store.getters['filters/currentPage']
      },
      set (newPage) {
        this.$store.dispatch('filters/setPage', newPage)
        this.$eventBus.$emit('onPageChange', newPage)
      }
    },
    allOrders () {
      return this.available
    },
    type () {
      return this.$attrs.type
    }
  },
  data () {
    return {
      hasSummited: false,
      hasData: true,
      checkboxPosition: 'left',
      isPaginated: true,
      isPaginationSimple: true,
      paginationPosition: 'top',
      checkedRows: [],
      checkedRestoreControl: [],
      iconOrd: 'sort-descending',
      defaultOrd: 'desc',
      elementVisible: true,
      generalBtnRestoreVisible: false
    }
  },
  components: {
    PartnerTableFilter,
    BtnRestoreOrder,
    TransportCommunications
  },
  watch: {
    allOrders (data) {
      data.forEach(o => {
        if (o.possibleToRevert) this.checkedRestoreControl.push(o.supplierOrderCode)
      })

      if (this.checkedRestoreControl.length) this.generalBtnRestoreVisible = true
    }
  },
  async mounted () {
    const filters = await this.$store.getters['filters/filtersSelected']
    const type = this.type

    const ok = await this.$store.dispatch('orders/getAvailableOrders', { filters, type })
    if (!ok.level) return this.wrong(this.$t(ok.errorText))

    this.hasSummited = true

    this.$eventBus.$on('emptyOrders', () => {
      this.hasSummited = true
      this.hasData = true
    })
    this.$eventBus.$on('orders', () => {
      this.hasData = true
      this.checkedRows = []
    })
    this.$eventBus.$on('cleanFilters', () => {
      this.hasData = false
    })
    this.$eventBus.$on('removeRestoreControl', data => {
      const { supplierOrderCode } = data
      if (!Array.isArray(supplierOrderCode) || supplierOrderCode.length === 0) return

      const filteredItems = this.checkedRestoreControl.filter(check => !(supplierOrderCode.toString()).includes(check))
      this.checkedRestoreControl = filteredItems

      if (this.checkedRestoreControl.length === 0) this.generalBtnRestoreVisible = false
    })
  },
  methods: {
    ord () {
      this.$store.dispatch('filters/setOrd', this.defaultOrd)

      if (this.defaultOrd === 'asc') {
        this.defaultOrd = 'desc'
        this.iconOrd = 'sort-descending'
      } else {
        this.defaultOrd = 'asc'
        this.iconOrd = 'sort-ascending'
      }

      this.$eventBus.$emit('getAvailableOrders')
    },
    async callActions (orders, type) {
      const data = {
        orders,
        type
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    },
    async downloadLabel (orders) {
      const labels = await services.labelService(orders)

      if (labels.okGenericLabel && labels.okGenericLabel.error) return this.wrong(this.$t('Errors.warningEdit', { orders: labels.okGenericLabel.customerOrderCode }))
      if (labels.okDHLLabel && labels.okDHLLabel.error) return this.wrong(this.$t('Errors.warningEdit', { orders: labels.okDHLLabel.customerOrderCode }))
      if (!labels.okGenericLabel || !labels.okDHLLabel) this.wrong(this.$t('Errors.somethingWrong'))
    },
    canSeeTransportComunications ({ partner }) {
      return this.checkPartner(partner)
    },
    _applySomeExceptions ({ deliveryPeriod }) {
      // ! MOVIMENT-1338 apply this exception until these slots was deleted from the system
      const exceptions = ['MORNING', 'AFTERNOON']

      const arrStrings = deliveryPeriod
        .split(' ')
        .map(item => item.trim())

      const onlyDescriptionString = arrStrings
        .slice(0, arrStrings.length - 3)
        .join(' ')

      const applyCorrectString = (exceptions.includes(onlyDescriptionString)) ? this.$t(`Orders.${onlyDescriptionString}`) : onlyDescriptionString.toUpperCase()
      return `${applyCorrectString}`
    },
    canRestore (order) {
      return order.possibleToRevert && order.partner.toUpperCase() !== 'CTT'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/PartnerOrders.vue